import Modal from 'antd/es/modal/Modal';
import Form from 'antd/es/form';
import Input from 'antd/es/input';
import Button from 'antd/es/button';
import Popconfirm from 'antd/es/popconfirm';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import {
  $adminChangePassModal,
  changeUserPasswordByAdminEv,
  changeUserPasswordByAdminFx,
} from '../../../models/adminSecurityModel/index.js';

export default function AdminPassChangeModal({ setModal }) {
  const { t } = useTranslation();
  const [passForm] = Form.useForm();

  const modal = useUnit($adminChangePassModal);

  const validPass = new RegExp(
    '^(?=.*[a-zA-Z0-9_!@#$%^&?*])(?=.*[A-Z])(?=.*[0-9])(?=.*[_!@#$%^&?*])[a-zA-Z0-9_!@#$%^&?*]{8,32}$'
  );

  const passInput = Form.useWatch('new_password', passForm);
  const onConfirm = useUnit(changeUserPasswordByAdminEv);
  const onCancel = () => {
    passForm.resetFields();
    setModal({ open: false, uId: null });
  };
  const loading = useUnit(changeUserPasswordByAdminFx.pending);

  return (
    <Modal
      title={t('Изменить пароль')}
      open={modal.open}
      footer={null}
      onCancel={onCancel}
    >
      <Form
        form={passForm}
        layout="vertical"
        validateTrigger={'onBlur'}
        onFinish={({ new_password }) =>
          onConfirm({ uId: modal.uId, new_password })
        }
      >
        <Form.Item
          name="new_password"
          label={t('Новый пароль')}
          rules={[
            { required: true, message: t('Обязательное поле') },
            {
              pattern: validPass,
              message: t(
                'Пароль должен содержать символы a-z, A-Z, 0-9, _!@#$%^&?*, длина 8-32'
              ),
            },
          ]}
        >
          <Input.Password />
        </Form.Item>
      </Form>
      <Popconfirm
        title={t('Вы уверены, что хотите изменить пароль?')}
        onConfirm={() => passForm.submit()}
        disabled={!passInput || passInput?.length < 8}
      >
        <Button
          type="primary"
          disabled={!passInput || passInput?.length < 8}
          loading={loading}
        >
          {t('Подтвердить')}
        </Button>
      </Popconfirm>
    </Modal>
  );
}
